<div class="d-flex flex-column">
  <div class="d-flex">
        <input-date [(value)]="date.day" (result)="changeValue()">
        </input-date>
        <div class="d-flex align-items-center ml-3" style="position: relative;" >
            <div (click)="showTime()" id="action{{id}}">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20"
                version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 122.88 122.88" style="enable-background:new 0 0 122.88 122.88" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M61.44,0c33.93,0,61.44,27.51,61.44,61.44c0,33.93-27.51,61.44-61.44,61.44C27.51,122.88,0,95.37,0,61.44 C0,27.51,27.51,0,61.44,0L61.44,0z M52.92,30.52h7.51c1.37,0,2.5,1.13,2.5,2.5v28.94h26.41c1.38,0,2.5,1.13,2.5,2.5v7.51 c0,1.38-1.13,2.5-2.5,2.5H50.41V33.02C50.41,31.64,51.54,30.52,52.92,30.52L52.92,30.52z M61.44,13.95 c26.23,0,47.49,21.26,47.49,47.49c0,26.23-21.26,47.49-47.49,47.49c-26.23,0-47.49-21.26-47.49-47.49 C13.95,35.22,35.21,13.95,61.44,13.95L61.44,13.95z"/></g></svg>            </div>
            <div class="popup-time" [hidden]="!isShowTime" id="{{id}}">
                <div class="d-flex flex-column">
                    <span class="title">Giờ</span>
                    <ul >
                        <li *ngFor="let hour of hours" id="scrollHour-{{hour}}-{{id}}"
                        (click)="changeHour(hour)" [ngClass]="{'active': date.hour === hour}" >
                            {{hour}}
                        </li>
                    </ul>
                </div>
                
                <div class="d-flex flex-column">
                    <span class="title">Phút</span>
                    <ul >
                        <li *ngFor="let minute of minutes" id="scrollMinute-{{minute}}-{{id}}"
                        (click)="changeMinute(minute)" [ngClass]="{'active': date.minute === minute}" >
                            {{minute}}
                        </li>
                    </ul>
                </div>
                
            </div>
            <span class="ml-2">{{date.time}}</span>
      </div>
  </div>
</div>